<template>
  <div class="house">
    <div class="househeader">
      <div style="display: flex; align-items: center">
        <img
          src="@/assets/house/breadicon.png"
          style="margin-right: 10px"
          alt
        />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>个人图库</el-breadcrumb-item>
          <el-breadcrumb-item>我的图集</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div @click="refresh" class="refresh">
        <img
          :class="isRefresh ? 'imgmove' : ''"
          width="16px"
          height="16px"
          src="@/assets/house/refresh.png"
          alt
        />
        <p>刷新</p>
      </div>
    </div>

    <div class="main" v-loading="isRefresh">
      <div class="head disflex">
        <div class="left">
          <h4 style="font-size: 18px; margin-left: 5px">我的图集</h4>
        </div>

        <div class="right disflex">
          <el-button
            v-if="powersObj.createAtlas"
            @click="addAtlasClick"
            :style="{
              backgroundColor: isCustom
                ? customColor
                : isSimple
                ? '#FD9112'
                : '#185ED3',
            }"
            class="btn"
            >新增图集</el-button
          >
          <div @click="sortClick" class="disflex">
            <p>按时间排序</p>
            <img
              style="margin: 3px 0 0 5px"
              :src="
                sortFlag
                  ? require('@/assets/personpic/down.png')
                  : isSimple
                  ? require('@/assets/personpic/simpleup.png')
                  : require('@/assets/personpic/up.png')
              "
              alt
            />
          </div>
        </div>
      </div>
      <div
        class="searchbj"
        :style="belongPicList.length > 15 ? 'height:200px' : ''"
      >
        <div class="belongpic">
          <h5>状态:</h5>
          <p
            v-for="(e, i) in statusList"
            :key="i"
            @click="statusClick(i, e.id)"
            :style="{
              backgroundColor:
                statusPicFlag === i
                  ? isCustom
                    ? customColor
                    : isSimple
                    ? '#FD9112'
                    : '#185ED3'
                  : '#ffffff',
            }"
            :class="statusPicFlag === i ? 'active' : ''"
          >
            {{ e.name }}
          </p>
          <!-- v-if="!batchFlag" -->
          <div class="batchY" v-if="false" @click="batch">
            <div class="img"></div>
            批量操作
          </div>
          <div v-if="batchFlag" class="batchN">
            <el-switch
              v-model="batchSwitch"
              @change="batchFun"
              :active-color="
                isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'
              "
              inactive-text="全选"
            >
            </el-switch>
            <el-button
              type="primary"
              class="change"
              :style="{
                backgroundColor: isCustom
                  ? customColor
                  : isSimple
                  ? '#FD9112'
                  : '#185ED3',
              }"
              @click="updateScret"
              >修改</el-button
            >
            <el-button
              type="primary"
              class="change"
              :style="{
                backgroundColor: isCustom
                  ? customColor
                  : isSimple
                  ? '#FD9112'
                  : '#185ED3',
              }"
              @click="deleteAtlas"
              >删除</el-button
            >
            <!-- <el-button type="primary"
                         class="change"
                         @click="deleteAtlas">删除</el-button> -->
            <el-button @click="cancleUpdateScret">取消</el-button>
          </div>
        </div>
        <div class="belongpic">
          <h5>图库:</h5>
          <p v-for="(e, i) in belongPicList" :key="i">
            <span
              v-if="!e.children"
              :style="{
                backgroundColor:
                  belongPicFlag === i
                    ? isCustom
                      ? customColor
                      : isSimple
                      ? '#FD9112'
                      : '#185ED3'
                    : '#ffffff',
              }"
              :class="belongPicFlag === i ? 'active' : ''"
              @click="picClick(i, e.id)"
              >{{ e.name }}</span
            >
            <span
              v-if="e.children && item.name"
              :style="{
                marginRight: '20px',
                backgroundColor:
                  belongPicFlag === index + (i*3) + 100
                    ? isCustom
                      ? customColor
                      : isSimple
                      ? '#FD9112'
                      : '#185ED3'
                    : '#ffffff',
              }"
              :class="belongPicFlag === index + (i*3) + 100 ? 'active' : ''"
              v-for="(item, index) in e.children"
              @click="picClick(index + (i*3) + 100, item.id)"
              :key="index"
            >
              <span>{{ item.name }}({{ e.name }})</span>
              
            </span>
          </p>
        </div>

        <div class="disFlex">
          <!-- 入库时间 -->
          <div class="coninput">
            <h5>入库时间:</h5>
            <el-date-picker
              v-model="warehousingTime"
              type="daterange"
              align="center"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <!-- <i class="dateicon el-icon-date"></i> -->
          </div>
          <!-- 关键字 -->
          <div class="coninput">
            <h5 style="width: 52px">关键字:</h5>
            <el-input
              class="elinput"
              v-model="selectInput"
              style="width: 300px"
              placeholder="请输入关键字"
            ></el-input>
            <!-- <i class="dateicon el-icon-date"></i> -->
          </div>

          <el-button
            @click="searchClick"
            :style="{
              backgroundColor: isCustom
                ? customColor
                : isSimple
                ? '#FD9112'
                : '#185ED3',
            }"
            class="btn"
            >搜索</el-button
          >
        </div>
      </div>
      <div
        class="piclist"
        :style="{
          gridTemplateColumns:
            picList.length < 5
              ? 'repeat(auto-fit, 290px)'
              : 'repeat(auto-fit, minmax(290px, 1fr))',
        }"
      >
        <!-- <template> -->
        <!-- <keep-alive> :style="{marginTop:i>=row && picList.length/row <= 2?'-46px':''}" -->
        <div
          :class="
            isCustom
              ? custom == 'xugong'
                ? 'mypic xg'
                : 'mypic wc'
              : isSimple
              ? 'mypic orange'
              : 'mypic blue'
          "
          v-if="!showGifFlag"
          v-for="(e, i) in picList"
          :key="i"
        >
          <div class="batchMask" v-if="batchFlag" @click="changeOnePic(i)">
            <img
              class="circle"
              :src="
                !e.updateFlag
                  ? require('@/assets/personpic/choose.png')
                  : isSimple
                  ? require('@/assets/personpic/simplechoosehover.png')
                  : require('@/assets/personpic/choosehover.png')
              "
            />
            <!-- <div v-show="e.updateFlag"
                 @click="changeOnePic(i)"
                 class="circleGreen"></div> -->
          </div>
          <div style="width: 100%; height: 180px; overflow: hidden">
            <div
              @click="intoPicList(e.id)"
              class="pic"
              :style="{ backgroundImage: 'url(' + e.src + ')' }"
            >
              <div class="sheets">
                <img src="@/assets/piclist/pic.png" alt="" />
                {{ e.pictureCount }}
                <img src="@/assets/piclist/video.png" alt="" />
                {{ e.videoCount }}
                <img src="@/assets/piclist/wordicon.png" alt="" />
                {{ e.documentCount || "0" }}
              </div>
            </div>
          </div>

          <el-tooltip
            class="item"
            effect="dark"
            :content="e.name"
            placement="top"
          >
            <p v-if="e.name.length > 13">{{ e.name.substring(0, 13) + "…" }}</p>
          </el-tooltip>
          <p v-if="e.name.length <= 13">{{ e.name }}</p>
          <div class="btnlist">
            <p
              :style="{
                marginTop: '5px',
                marginRight: e.pictureCount > 0 ? '15px' : '35px',
                color: '#999999',
              }"
            >
              {{ e.mycreateAt }}
            </p>
            <div style="display: flex; align-items: center">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看/修改图集信息"
                placement="top"
              >
                <img
                  @click.stop="seeAtlas(e)"
                  style="cursor: pointer; margin-right: 5px"
                  src="@/assets/piclist/edit.png"
                  alt=""
                />
                <!-- <el-button @click.stop="seeAtlas(e)"
                          class="seeInfo"
                          type="info"
                          icon="el-icon-edit-outline"
                          circle></el-button> -->
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                content="分享图集"
                placement="top"
              >
                <div
                  v-if="powersObj.picturePush && e.pictureCount > 0"
                  @click.stop="sharePicAtlas(e)"
                  :class="isSimple ? 'simplebtn disflex' : 'btn disflex'"
                >
                  <div class="imgshare"></div>
                </div>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                content="公开"
                placement="top"
              >
                <img
                  @click.stop="!statusFlag && changeStatus(e)"
                  v-if="e.status === 1"
                  style="cursor: pointer; margin-right: 5px"
                  src="@/assets/piclist/open.png"
                  alt=""
                />
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                content="私密"
                placement="top"
              >
                <img
                  @click.stop="!statusFlag && changeStatus(e)"
                  v-if="e.status !== 1"
                  style="cursor: pointer; margin-right: 5px"
                  src="@/assets/piclist/private.png"
                  alt=""
                />
              </el-tooltip>
            </div>
          </div>
        </div>
        <div v-if="showGifFlag" class="showGifFlag">
          <img width="200px" src="@/assets/blue-preloader.gif" alt />
        </div>
        <!-- </keep-alive> -->
        <!-- </template> -->
        <!-- <template v-if="picList.length%row > 0">
          <div class="list" :style="{width:widthWithUP}" v-for="(item,index) in (row-(picList.length)%row)" :key="'list'+index"></div>
        </template> -->

        <template v-if="picList.length === 0">
          <div class="nopic">
            <img src="@/assets/piclist/nonr.png" alt="" />
          </div>
        </template>

        <img
          v-if="showLoading"
          class="myloading"
          width="200px"
          src="@/assets/blue-preloader.gif"
          alt
        />
      </div>
    </div>

    <changedescdialog
      :message="message"
      :dialogVisible="descdialogVisible"
      @handleClose="deschandleClose"
      @changeDesc="changeDesc"
    ></changedescdialog>

    <!-- 新增/修改图集 -->
    <el-dialog
      :visible.sync="dialogVisiblePutIn"
      width="26%"
      :before-close="handleClosePutIn"
    >
      <div
        slot="title"
        class="header-title"
        :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
      >
        <div>{{ atlasName }}</div>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rulesaddpic"
        ref="addRuleForm"
        label-width="95px"
        class="demo-ruleForm"
        v-loading="dialogLoading"
      >
        <el-form-item label="归属图库:" prop="region">
          <el-cascader
            style="width: 100%"
            v-model="ruleForm.region"
            :options="options"
          ></el-cascader>
          <!-- <el-select v-model="ruleForm.region"
                     style="width:100%;"
                     placeholder="请选择图片库">
            <el-option v-for="item in options"
                       :key="item.value + '-0'"
                       :label="item.label"
                       :value="item.value"
                       v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="图集名:" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入图集名"
          ></el-input>
        </el-form-item>
        <el-form-item label="可见性:" prop="status">
          <el-radio-group
            :disabled="isSave || statusFlag"
            :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
            style="margin-top: 5px"
            v-model="ruleForm.status"
            size="small"
          >
            <el-radio-button label="0">私密</el-radio-button>
            <el-radio-button label="1">公开</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="图集说明:" prop="desc">
          <el-input
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 12 }"
            v-model="ruleForm.desc"
            placeholder="选填，图集说明不超过200个字"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button :disabled="dialogLoading" @click="handleClosePutIn"
          >取 消</el-button
        >
        <el-button
          :disabled="dialogLoading"
          type="primary"
          :style="{
            border: 'none',
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          @click="subPutIn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改图集私密及图库 -->
    <!-- updateScretDia -->
    <el-dialog
      :visible.sync="updateScretDia"
      width="30%"
      :before-close="handleCloseScret"
    >
      <div
        slot="title"
        class="header-title"
        :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
      >
        <div>批量修改图集信息</div>
      </div>
      <div>
        <template>
          <div style="display: flex; align-items: center">
            <div>图库：</div>
            <el-select v-model="selectValue" placeholder="请选择图库">
              <el-option
                v-for="item in belongPicList"
                :key="item.id"
                :label="item.name"
                v-if="item.id !== 0"
                :value="item.id"
                v-html="'<span style=color:#303030;>' + item.name + '</span>'"
              >
              </el-option>
            </el-select>
          </div>
        </template>
        <div style="margin-top: 20px; display: flex; align-items: center">
          <div>图集状态：</div>
          <el-radio-group
            :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
            :disabled="statusFlag"
            v-model="scretOpenFlag"
          >
            <el-radio-button label="0">私密</el-radio-button>
            <el-radio-button label="1">公开</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseScret">取 消</el-button>
        <el-button
          type="primary"
          :style="{
            border: 'none',
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          @click="sureUpdateAtlas"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      width="26%"
      :before-close="handleCloseWork"
      :visible.sync="dialogVisibleWork"
    >
      <div
        slot="title"
        class="header-title"
        :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom
            ? customColor
            : isSimple
            ? '#FD9112'
            : '#185ED3',
        }"
      >
        <div>分享至工作圈</div>
        <div class="dialogmessage">
          <p>目前视频资源暂时不支持分享！</p>
        </div>
      </div>

      <el-form
        :model="workForm"
        ref="workForm"
        label-width="110px"
        style="margin-top: 10px"
        :rules="workRules"
      >
        <el-form-item label="标题：" prop="name">
          <el-input
            v-model="workForm.name"
            placeholder="必填，2-10个字"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择工作圈：" prop="work">
          <!-- multiple -->
          <el-select
            :remote-method="selectWork"
            remote
            v-model="workForm.work"
            filterable
            style="width: 100%"
            placeholder="请选择工作圈"
          >
            <el-option
              style="width: 100%"
              v-for="item in workList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-html="'<span style=color:#303030;>' + item.name + '</span>'"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label" class="labelclass">备注：</div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 7 }"
            v-model="workForm.note"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseWork">取 消</el-button>
        <el-button
          type="primary"
          :style="{
            border: 'none',
            backgroundColor: isCustom
              ? customColor
              : isSimple
              ? '#FD9112'
              : '#185ED3',
          }"
          @click="submitWork('workForm')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { searchAtlas } from "@/api/search";
import {
  listUnclutteredPicture,
  deletePicture,
  updatePicture,
  bindingAtlas,
} from "@/api/picture";
import { formatConversion } from "@/plugins/getdate";
import { listLib, listMyPowerLib } from "@/api/lib";
import { listWorkgroup } from "@/api/workgroup";
import { picPrefix } from "@/constants/piccommon";
import { addPicturePackage, getPicturePackage } from "@/api/picturePackage";
import {
  getAtlasSonIds,
  deleteAtlas,
  addAtlas,
  updateAtlas,
  generateIndexPic,
  batchUpdateAtlas,
} from "@/api/atlas";
import { powersObj, allowLib } from "@/constants/powers";

import { changedescdialog } from "@/components/index";

import picview from "@/components/picView/picView";
export default {
  inject: ["reload"],
  components: { changedescdialog, picview },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data() {
    return {
      //可见性权限
      statusFlag: false,

      //新建图集
      dialogVisiblePutIn: false,
      ruleForm: {
        name: "",
        region: "",
        desc: "",
        status: "0",
      },
      rulesaddpic: {
        name: [
          { required: true, message: "请输入图集名", trigger: "change" },
          {
            min: 1,
            max: 60,
            message: "长度在 1 到 60 个字符",
            trigger: "blur",
          },
        ],
        region: [
          { required: true, message: "请选择图片库", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择可见性", trigger: "change" },
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur",
          },
        ],
      },
      dialogLoading: false,

      //图集信息
      atlasInfo: null,

      //筛选内容
      belongPicList: [
        {
          id: 0,
          name: "全部",
        },
      ],
      //状态筛选
      statusList: [
        {
          id: -1,
          name: "全部",
        },
        {
          id: 0,
          name: "私密",
        },
        {
          id: 1,
          name: "公开",
        },
      ],
      belongPicFlag: 0,
      statusPicFlag: 0,
      warehousingTime: [],
      picId: "",
      statusId: "",
      timeStart: "",
      timeEnd: "",
      selectInput: "",

      //标记人物
      dialogVisible: false,

      //根据分辨率判断长度
      documentHeight: 0,
      minRows: 8,
      maxRows: 12,

      //权限
      powersObj,
      allowLib,

      //批量操作
      plFlag: true,

      //分辨率
      row: 1,
      widthWithUP: "",
      displayResolution: 0,

      //图集间距
      atlasMargin: "",

      //侧边栏是否收起
      isAside: this.bus.val,

      picPrefix,

      //选中的图片
      choosePic: [],

      atlasId: "",
      libId: "",
      isSave: false,

      //是按天还是按月排序
      picSortFlag: true,
      picinfClass: "picinf",

      //时间排序
      sortFlag: true,

      //未整理图片的个数
      nnclutteredPic: "",

      currentPage: 0,

      //显示我的图集还是未整理图片   0为图集
      isPic: 0,

      //分页
      total: 0,
      pageSize: 15,
      page: 0,
      totalPic: 0,
      pageSizePic: 10,
      pagePic: 0,
      orderByTime: 0,

      //所有图集
      picList: [],

      faceMarginTop: "",

      isRefresh: false,

      visibility: "公开",
      options: [],
      visibilityList: [
        {
          value: "1",
          label: "公开",
        },
        {
          value: "0",
          label: "私密",
        },
      ],
      atlasForm: {
        libId: "",
        name: "",
        desc: "",
        status: "",
        sourceType: "0",
        indexpicId: "0",
        createUid: this.createUid,
      },
      rules: {
        name: [{ required: true, message: "请输入图集名称", trigger: "blur" }],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度在 200 个字符以内",
            trigger: "blur",
          },
        ],
        libId: [
          { required: true, message: "请选择归属图库", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择可见性", trigger: "change" },
        ],
      },
      pic: {
        id: 4278,
        name: "",
        src: "",
      },

      //归档图集
      uploadMode: 0,
      myselect: "",
      myAtlas: [],
      myLibId: 0,
      myAtlasId: 0,
      isReLoad: false,
      isDelete: false,
      alreadyPicLength: 0,

      //查看图片相关
      atlasName: "新建图集",

      //图片说明
      descdialogVisible: false,
      message: "",

      //查看未整理图片相关
      picdialogVisible: false,
      passChoose: {},
      inPicList: [],
      showLoading: false,
      passFlag: true,

      batchFlag: false, //批量标志
      batchSwitch: false, //全选标志
      updateScretDia: false, //修改图集私密及图库对话框
      scretOpenFlag: 0, //修改图库的私密公开
      mapDepot: [], //修改图集时的图库列表
      picIds: [], //选中的修改图集

      selectValue: "", //select的默认值
      showGifFlag: false,

      //分享到工作圈
      dialogVisibleWork: false,
      shareAtlasId: 0,
      workForm: {
        name: "",
        work: "",
        createUid: this.createUid,
        note: "",
      },
      workRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        work: [{ required: true, message: "请选择工作圈", trigger: "change" }],
      },
      workList: [],
    };
  },
  methods: {
    //图集分享
    sharePicAtlas(e) {
      this.$confirm("确定分享图集？", {
        confirmButtonClass: this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm",
      }).then(() => {
        this.shareAtlasId = e.id;
        this.dialogVisibleWork = true;
        this.listWorkgroupAsync();
      });
    },
    //分享关闭
    handleCloseWork() {
      this.$refs["workForm"].resetFields();
      this.dialogVisibleWork = false;
    },
    //分享到工作圈
    submitWork(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          let { status, data, message } = await getAtlasSonIds(
            this.shareAtlasId
          );
          let picid = data.toString();
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: "share",
            pictureCount: data.length,
            pictureIds: picid,
            targetUid: 0,
            targetWorkgroupId: this.workForm.work,
            title: this.workForm.name,
            shareConfig: JSON.stringify({
              pushChannelId: "",
              note: this.workForm.note,
            }),
          };

          this.addPicturePackageAsync(choosePicMsg);

          this.dialogVisibleWork = false;
          this.workForm = {};
          setTimeout(() => {
            this.$router.push("/shareAndPush/myShare");
          }, 1500);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //增加图片包
    async addPicturePackageAsync(val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("创建成功！");
        // this.setDrawer(false)
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //工作圈筛选
    selectWork(query) {
      let dataExa;
      if (query !== "") {
        dataExa = { page: 0, pageSize: 20, keyword: query };
        this.listWorkgroupAsync(dataExa);
      } else {
        dataExa = { page: 0, pageSize: 20 };
        this.listWorkgroupAsync(dataExa);
      }
    },

    //获取工作圈列表
    async listWorkgroupAsync(val) {
      let { status, data, message, errors } = await listWorkgroup(val);
      if (status) {
        this.workList = data;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    sureUpdateAtlas() {
      //dia确认修改图集
      let picIds = [];

      // if (this.scretOpenFlag == '') {
      //   this.$message.error('请选择私密或者公开！')
      //   return;
      // }
      // if (this.selectValue == 0) {
      //   this.$message.error('请选择图库！')
      //   return;
      // }
      picIds = this.picIds.join(",");
      this.updateScretDia = false;

      let val = {
        // ids: picIds,
        status: this.scretOpenFlag,
        libId: this.selectValue,
      };
      console.log(val);
      this.batchUpdateAtlasAsync(picIds, val);
    },
    async batchUpdateAtlasAsync(picIds, val) {
      //批量修改图集
      let { status, data, message, error } = await batchUpdateAtlas(
        { ids: picIds },
        val
      );
      if (status) {
        this.picClick(
          this.belongPicFlag,
          this.belongPicList[this.belongPicFlag].id
        );
        this.batchSwitch = false;
        //获取图集
        // this.searchAtlasAsync({ pageSize: this.pageSize, page: this.page, orderByTime: this.orderByTime, createUid: this.createUid })
        this.$message.success(message);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
    changeOnePic(index) {
      //修改图集状态
      console.log(this.picList[index].updateFlag);
      this.picList[index].updateFlag = !this.picList[index].updateFlag;
      this.$forceUpdate();
      for (let i = 0; i < this.picList.length; i++) {
        if (!this.picList[i].updateFlag) {
          this.batchSwitch = false;
          return;
        }
        if (i === this.picList.length - 1) {
          this.batchSwitch = true;
        }
      }
    },
    handleCloseScret() {
      this.scretOpenFlag = "";
      this.selectValue = "";
      this.updateScretDia = false;

      console.log(this.belongPicList);
    },
    updateScret() {
      //修改图集私密及图库
      this.picIds = [];
      for (let i = 0; i < this.picList.length; i++) {
        if (this.picList[i].updateFlag) {
          this.picIds.push(this.picList[i].id);
        }
      }
      if (this.picIds.length == 0) {
        this.$message.error("请选择图集！");
        this.updateScretDia = false;
        return;
      }
      this.updateScretDia = true;
    },
    deleteAtlas() {
      //删除图集
      this.$confirm("确认删除已选图集吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: this.isCustom
          ? this.custom == "xugong"
            ? "xgfirm"
            : "wcfirm"
          : this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm", //点击删除
      })
        .then(() => {
          this.picIds = [];
          for (let i = 0; i < this.picList.length; i++) {
            if (this.picList[i].updateFlag) {
              this.picIds.push(this.picList[i].id);
            }
          }
          for (let i = 0; i < this.picIds.length; i++) {
            this.deleteAtlasAsync(this.picIds[i], i);
          }
        })
        .catch(() => {});
    },
    cancleUpdateScret() {
      //取消修改图集私密及图库
      this.batchFlag = false;
      this.batchSwitch = false;
    },
    batchFun() {
      //改变batchFlag
      console.log(this.batchSwitch);
      if (this.batchSwitch) {
        for (let i = 0; i < this.picList.length; i++) {
          this.picList[i].updateFlag = true;
        }
      } else {
        for (let i = 0; i < this.picList.length; i++) {
          this.picList[i].updateFlag = false;
        }
      }
    },
    batch() {
      //批量操作
      for (let i = 0; i < this.picList.length; i++) {
        this.picList[i].updateFlag = false;
      }
      this.checkStatus();
      this.batchFlag = true;
    },
    //修改图片说明
    changeDesc(val) {
      this.updatePictureAsync(val);
      this.descdialogVisible = false;
    },
    deschandleClose() {
      this.descdialogVisible = false;
    },
    openChangeDesc(val) {
      // console.log(val)
      this.message = val;
      this.listLibAsync();
      this.descdialogVisible = true;
    },
    //修改图片说明
    async updatePictureAsync(val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！");
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查看图集信息
    seeAtlas(e) {
      this.atlasName = "图集信息";
      this.checkStatus();
      this.ruleForm = {
        name: e.name,
        region:
          e.parentLibId == 0 ? e.libId : [e.parentLibId, e.libId.toString()],
        desc: e.desc,
        status: e.status,
        id: e.id,
        indexpicId: e.indexpicId,
        sourceType: e.sourceType,
      };
      if (powersObj.createPrivateAtlas) {
        if (this.ruleForm.status == 1) {
          this.statusFlag = false;
        }
      }
      if (powersObj.createPublicAtlas) {
        if (this.ruleForm.status == 0) {
          this.statusFlag = false;
        }
      }
      // this.checkStatus()

      this.dialogVisiblePutIn = true;
      // console.log(e)
    },

    //筛选内容
    picClick(i, id) {
      this.batchSwitch = false;
      this.belongPicFlag = i;
      this.picId = id;
      this.searchClick()
    },

    //状态筛选
    statusClick(i, id) {
      this.statusPicFlag = i;
      this.statusId = id;
      this.searchClick();
    },

    searchClick() {
      this.showGifFlag = true;

      if (this.warehousingTime) {
        this.warehousingTime[0] = this.warehousingTime[0];
        this.warehousingTime[1] = this.warehousingTime[1] + 86400000;
        if (this.warehousingTime[0]) {
          this.timeStart = this.warehousingTime[0] / 1000;
          this.timeEnd = this.warehousingTime[1] / 1000;
        }
      } else {
        this.timeStart = "";
        this.timeEnd = "";
      }

      if (this.belongPicFlag === 0) {
        this.picId = "";
      }
      this.pagePic = 0;
      this.page = 0;
      this.orderByTime = 0;
      let params = {
        createUid: this.createUid,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
        status: this.statusId,
      };
      this.searchAtlasAsync(params);
    },

    myAtlasClick() {
      this.isPic = 0;
      this.uploadMode = 0;
      this.choosePic = [];
    },

    changeUploadMode() {
      if (this.uploadMode === 0) {
        this.uploadMode = 1;
      } else {
        this.uploadMode = 0;
      }
    },
    rowClick(row) {
      // this.myLibId = row.libId
      this.myAtlasId = row.atlasId;
    },
    myLibChange() {
      // console.log(this.myselect)
      if (!this.myselect) {
        this.myAtlas = [];
        this.mySearchAtlasAsync({
          pageSize: 50,
          page: 0,
          createUid: this.createUid,
        });
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = [];
        this.mySearchAtlasAsync({
          keyword: this.myselect,
          pageSize: 50,
          page: 0,
          createUid: this.createUid,
        });
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    async mySearchAtlasAsync(val) {
      let { status, data, message } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.myAtlas.push({
            name:
              "[" +
              (data[i].libInfo ? data[i].libInfo.name : "暂无") +
              "] " +
              data[i].name,
            date: formatConversion(data[i].createAt.toString()),
            libId: data[i].libId,
            atlasId: data[i].id,
          });
        }

        // this.myAtlasId = this.myAtlas[0].label;
      } else {
      }
    },

    //判断可见性是否有权限
    checkStatus() {
      let createLength = 0;

      if (powersObj.createPrivateAtlas) {
        this.statusFlag = true;
        this.ruleForm.status = "0";
        this.scretOpenFlag = "0";
      } else {
        createLength++;
      }
      if (powersObj.createPublicAtlas) {
        this.statusFlag = true;
        this.ruleForm.status = "1";
        this.scretOpenFlag = "1";
      } else {
        createLength++;
      }

      if (createLength == 2) {
        this.isSave = true;
        this.statusFlag = true;
        this.$message.warning("请联系管理员添加可见性的权限！");
      }

      if (createLength == 0) {
        this.statusFlag = false;
        this.ruleForm.status = "0";
        this.scretOpenFlag = "0";
      }
    },

    //新增图集
    addAtlasClick() {
      this.atlasName = "新建图集";
      this.dialogVisiblePutIn = true;
      this.ruleForm = {
        name: "",
        region: "",
        desc: "",
        status: "0",
      };

      this.checkStatus();

      // this.$refs["addRuleForm"].resetFields();
      // this.listLibAsync()
    },
    handleClosePutIn() {
      this.ruleForm = {
        name: "",
        region: "",
        desc: "",
        status: "0",
      };
      this.$refs["addRuleForm"].resetFields();
      this.dialogVisiblePutIn = false;
    },
    dev() {
      this.$message("正在开发中……");
    },

    subPutIn() {
      this.$refs["addRuleForm"].validate((valid) => {
        if (valid) {
          this.dialogLoading = true;
          let nowPage = this.page;
          if (this.atlasName == "新建图集") {
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              sourceType: "0",
              createUid: this.createUid,
              indexpicId: "0",
            };

            this.addAtlasAsync(data);
            for (let i = 0; i < nowPage; i++) {
              this.page = i;
              this.searchAtlasAsync({
                status: this.statusId,
                timeEnd: this.timeEnd,
                timeStart: this.timeStart,
                libId: this.picId,
                keyword: this.selectInput,
                pageSize: this.pageSize,
                page: this.page,
                orderByTime: this.orderByTime,
                createUid: this.createUid,
              });
            }

            this.dialogVisiblePutIn = false;

            // setTimeout(() => {
            //   this.$router.push({
            //     name: "pictureUpload", //跳转的路径
            //     params: {
            //       atlas: this.atlasInfo
            //     }
            //   });
            // }, 500);
          } else {
            this.dialogVisiblePutIn = false;
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region.length==2 ? this.ruleForm.region[1]:this.ruleForm.region[0],
              parentLibId: this.ruleForm.region.length==2 ? this.ruleForm.region[0]:0,
              status: this.ruleForm.status,
              createUid: this.createUid,
              id: this.ruleForm.id,
              indexpicId: this.ruleForm.indexpicId,
              sourceType: this.ruleForm.sourceType,
            };
            this.updateAtlasAsync(data);
            for (let i = 0; i < nowPage; i++) {
              this.page = i;
              this.searchAtlasAsync({
                status: this.statusId,
                timeEnd: this.timeEnd,
                timeStart: this.timeStart,
                libId: this.picId,
                keyword: this.selectInput,
                pageSize: this.pageSize,
                page: this.page,
                orderByTime: this.orderByTime,
                createUid: this.createUid,
              });
            }
            // this.searchAtlasAsync({ pageSize: this.pageSize, page: this.page, orderByTime: this.orderByTime, createUid: this.createUid })
          }
        } else {
          return false;
        }
      });
    },

    //刷新表格
    refresh() {
      this.updateScretDia = false;
      this.batchFlag = false;
      this.picId = "";
      this.timeStart = "";
      this.timeEnd = "";
      this.warehousingTime = [];
      this.belongPicFlag = 0;
      this.belongPicList = [
        {
          id: 0,
          name: "全部",
        },
      ];
      this.selectInput = "";
      this.isRefresh = true;
      this.page = 0;
      this.pageFace = 0;
      this.orderByTime = 0;
      // this.isPic = true
      this.sortFlag = true;

      //获取图集
      let params = {
        createUid: this.createUid,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
        status: this.statusId,
      };
      this.searchAtlasAsync(params);

      //获取图库列表
      this.listLibAsync();

      this.displayResolution = document.documentElement.clientWidth;

      setInterval(() => {
        this.judgRes();
      }, 666);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    changeStatus(e) {
      console.log(e);
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: this.isCustom
          ? this.custom == "xugong"
            ? "xgfirm"
            : "wcfirm"
          : this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm", //点击删除
      }).then((es) => {
        if (e.libId !== 0) {
          let closeMsg = e;
          if (closeMsg.status === 0) {
            closeMsg.status = 1;
          } else {
            closeMsg.status = 0;
          }
          this.updateAtlasAsync(closeMsg);
        } else {
          console.log(2);
          this.$message.warning("请选择图库！");
          this.seeAtlas(e);
        }
      });
    },
    //修改图集信息
    async updateAtlasAsync(val) {
      let { status, data, message, errors } = await updateAtlas(val);
      this.dialogLoading = false;
      if (status) {
        this.$message.success("修改成功！");
        this.searchClick();
        this.reload();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //选择图片
    choosePicClick(id, i) {
      if (this.choosePic.indexOf(id) === -1) {
        this.choosePic.push(id);
        this.testList[i].indeterminate = true;
        this.testList[i].chooseFlag++;
        if (this.testList[i].chooseFlag === this.testList[i].picList.length) {
          this.testList[i].time420 = true;
          this.testList[i].indeterminate = false;
        }
      } else {
        this.choosePic.splice(this.choosePic.indexOf(id), 1);
        this.testList[i].chooseFlag--;

        if (this.testList[i].chooseFlag === 0) {
          this.testList[i].indeterminate = false;
          this.testList[i].time420 = false;
        } else {
          this.testList[i].indeterminate = true;
          this.testList[i].time420 = false;
        }
      }
    },

    //选择改变的图片
    choosePicChange(check, pl, index) {
      this.testList[index].indeterminate = false;
      if (check) {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) === -1) {
            this.choosePic.push(e.id);
            this.testList[index].chooseFlag++;
          }
        });
      } else {
        pl.forEach((e, i) => {
          if (this.choosePic.indexOf(e.id) !== -1) {
            this.choosePic.splice(this.choosePic.indexOf(e.id), 1);
            this.testList[index].chooseFlag--;
          }
        });
      }
    },

    //图片保存
    save(formName) {
      // console.log(this.choosePic)

      if (this.testList.length === 0 || this.testListMonth.length === 0) {
        this.$message.warning("暂无内容可选择！");
        return;
      }

      if (this.choosePic.length === 0) {
        this.$message.warning("请选择图片");
        return;
      }

      if (this.uploadMode !== 0) {
        if (this.myAtlasId !== 0) {
          this.atlasId = this.myAtlasId;

          this.choosePic.forEach((e, i) => {
            let picMsg = {
              atlasId: this.atlasId,
              pictureId: e,
            };
            this.bindingAtlasAsync(picMsg);
          });

          this.$refs["ruleForm"].resetFields();
          this.isSave = false;

          setTimeout(() => {
            this.atlasId = "";
            this.reload();
          }, 1000);
        } else {
          this.$message.warning("请选择图集");
        }
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isSave = true;
            this.addAtlasAsync(this.atlasForm);

            // console.log(1)
          } else {
            return false;
          }
        });
      }
    },

    //排序
    sortClick() {
      this.sortFlag = !this.sortFlag;
      this.page = 0;
      if (this.orderByTime === 0) {
        this.orderByTime = 1;
      } else {
        this.orderByTime = 0;
      }

      let params = {
        createUid: this.createUid,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
      };
      this.searchAtlasAsync(params);
    },

    intoPicList(id) {
      this.$router.push({
        name: "myLibShow", //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: id,
        },
      });
    },

    //滚动加载图库和图片
    scrollPic() {
      // let isBottom = (document.documentElement.scrollTop + window.innerHeight) === document.body.offsetHeight

      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;

      // var scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // console.log(scrollTop + windowHeight == scrollHeight)
      // this.pic.id = scrollTop
      if (isBottom) {
        // if (this.isPic === 0) {

        if (this.picList.length !== this.total) {
          this.showLoading = true;
          setTimeout(() => {
            this.page++;
            this.showLoading = false;
            this.searchAtlasAsync({
              pageSize: this.pageSize,
              page: this.page,
              status: this.statusId,
              libId: this.picId,
              orderByTime: this.orderByTime,
              timeStart: this.timeStart,
              timeEnd: this.timeEnd,
              createUid: this.createUid,
            });
            // console.log(this.picList)
          }, 1000);
        }

        // } else if (this.isPic === 1) {

        // } else if (this.isPic == 2) {

        // }
      }
      if (scrollTop >= 216) {
        this.picinfClass = "picinf picinfpos";
      } else {
        this.picinfClass = "picinf";
      }
    },

    //检索图集
    async searchAtlasAsync(val) {
      this.isRefresh = true;
      let { status, data, message, pagination, errors } = await searchAtlas(
        val
      );
      if (status) {
        if (this.page === 0) {
          this.picList = data;
        } else {
          for (let i = 0; i < data.length; i++) {
            this.picList.push(data[i]);
          }
        }
        if (this.picList.length == 0) {
          this.row = 1;
        } else {
          this.checkRow();
        }
        this.total = pagination.total;
        for (let i = 0; i < this.picList.length; i++) {
          this.picList[i].mycreateAt = formatConversion(
            this.picList[i].createAt.toString()
          );

          if (
            this.picList[i].indexpicPath == "" &&
            this.picList[i].pictureCount !== 0
          ) {
            await generateIndexPic({
              atlasId: this.picList[i].id,
              isForce: true,
            });
          }

          if (this.picList[i].indexpicPath === "") {
            this.picList[i].src = require("@/assets/house/onloadpic.png");
          } else {
            this.picList[i].src = picPrefix + this.picList[i].indexpicPath;
          }

          if (this.picList[i].pictureCount == 0) {
            this.picList[i].src = require("@/assets/house/onloadpic.png");
          }
        }
        // this.picList = this.picList.splice(0,1)
        this.$forceUpdate();
        this.isRefresh = false;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
      this.showGifFlag = false;
    },

    //删除图集
    async deleteAtlasAsync(val, index) {
      // console.log(val,index);
      // console.log(this.picIds.length);
      let { status, data, message, errors } = await deleteAtlas(val);
      if (status) {
        if (index == this.picIds.length - 1) {
          this.$message.success("删除成功！");
          this.batchSwitch = false;
          this.refresh();
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建图集
    async addAtlasAsync(val) {
      let libArr = val.libId;
      if (libArr.length >= 2) {
        val.parentLibId = parseInt(libArr[0]);
        val.libId = parseInt(libArr[1]);
      } else {
        val.parentLibId = 0;
        val.libId = parseInt(libArr[0]);
      }
      let { status, data, message, errors } = await addAtlas(val);
      this.dialogLoading = false;
      if (status) {
        // this.$message.success("添加成功！");
        this.atlasId = data.id;
        this.libId = data.libId;
        this.atlasInfo = data;

        // console.log(this.choosePic)

        this.choosePic.forEach((e, i) => {
          let picMsg = {
            atlasId: this.atlasId,
            pictureId: e,
          };
          this.bindingAtlasAsync(picMsg);
        });

        // this.$refs['ruleForm'].resetFields();
        this.isSave = false;

        setTimeout(() => {
          this.reload();
          this.$router.push({
            name: "pictureUpload", //跳转的路径
            params: {
              atlas: data,
            },
          });
        }, 1000);
        // this.isPic = 0

        // this.searchAtlasAsync({pageSize:this.pageSize,page:0,orderByTime : this.orderByTime,createUid:this.createUid})

        // this.listUnclutteredPictureAsync({uid:this.createUid})
        // this.$router.push({
        //   name: "piccenter", //跳转的路径
        // });
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建图片对象
    async bindingAtlasAsync(val) {
      let { status, data, message, errors } = await bindingAtlas(val);
      if (status) {
        this.uploadMode = 0;
        this.nnclutteredPic = [];
        this.listUnclutteredPictureAsync({ uid: this.createUid });
        this.atlasId = 0;
        this.libId = 0;
        this.alreadyPicLength++;
        if (this.alreadyPicLength == this.choosePic.length) {
          this.$message.success("添加成功！");
          this.alreadyPicLength = 0;
          this.choosePic = [];
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片列表
    async listMyPowerLibAsync() {
      let { status, data, message, pagination } = await listMyPowerLib();
      if (status) {
        this.options = [];
        this.belongPicList = [
          {
            id: 0,
            name: "全部",
          },
        ];
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.options.push({
                value: data[i].id,
                label: data[i].name,
                children: [],
              });
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
                children: [],
              });
            }
          }
        }

        for (let i = 0; i < this.options.length; i++) {
          let flag = 0;
          for (let j = 0; j < this.allowLib.length; j++) {
            if (this.allowLib[j].toString().indexOf("-") !== -1) {
              if (this.options[i].value == this.allowLib[j].split("-")[0]) {
                flag++;
                this.options[i].children.push({
                  value: this.allowLib[j].split("-")[1],
                  label: "",
                });
              }
            }
          }
          if (flag == 0) {
            delete this.options[i].children;
          }
        }

        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].hasOwnProperty("children")) {
            if (this.options[i].children.length > 0) {
              let spliceNum = []
              for (let z = 0; z < this.options[i].children.length; z++) {
                for (let j = 0; j < data.length; j++) {
                  if (data[j].id == this.options[i].children[z].value) {
                    if(data[j].status === 1){
                      this.options[i].children[z].label = data[j].name
                    }else{
                      spliceNum.push(z)
                    }
                  }
                }
              }

              for (let index = 0; index < spliceNum.length; index++) {
                this.options[i].children.splice(spliceNum[index] - index,1)
              }
              
              if(this.options[i].children.length == 0){
                delete this.options[i]
              }
            }
          }
        }

        for (let i = 0; i < this.belongPicList.length; i++) {
          let flag = 0;
          for (let j = 0; j < this.allowLib.length; j++) {
            if (this.allowLib[j].toString().indexOf("-") !== -1) {
              if (this.belongPicList[i].id == this.allowLib[j].split("-")[0]) {
                flag++;
                this.belongPicList[i].children.push({
                  id: this.allowLib[j].split("-")[1],
                  name: "",
                });
              }
            }
          }
          if (flag == 0) {
            delete this.belongPicList[i].children;
          }
        }

        for (let i = 0; i < this.belongPicList.length; i++) {
          if (this.belongPicList[i].hasOwnProperty("children")) {
            if (this.belongPicList[i].children.length > 0) {
              for (let z = 0; z < this.belongPicList[i].children.length; z++) {
                for (let j = 0; j < data.length; j++) {
                  if (data[j].id == this.belongPicList[i].children[z].id) {
                    this.belongPicList[i].children[z].name = data[j].name;
                  }
                }
              }
            }
          }
        }
        // console.log(this.options,12121212);
      }
    },

    //获取图片库列表
    async listLibAsync() {
      let { status, data, message } = await listLib({ pageSize: 100 });
      if (status) {
        this.belongPicList = [
          {
            id: 0,
            name: "全部",
          },
        ];
        this.options = [];
        if (localStorage.getItem("createUid") == 60000) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
              this.options.push({
                value: data[i].id,
                label: data[i].name,
                children: [],
              });
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
                children: [],
              });
            }
          }

          for (let i = 0; i < this.options.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (this.options[i].value == this.allowLib[j].split("-")[0]) {
                  flag++;
                  this.options[i].children.push({
                    value: this.allowLib[j].split("-")[1],
                    label: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.options[i].children;
            }
          }

          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].hasOwnProperty("children")) {
              if (this.options[i].children.length > 0) {
                let spliceNum = []
                for (let z = 0; z < this.options[i].children.length; z++) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.options[i].children[z].value) {
                      if(data[j].status === 1){
                        this.options[i].children[z].label = data[j].name
                      }else{
                        spliceNum.push(z)
                      }
                    }
                  }
                }

                for (let index = 0; index < spliceNum.length; index++) {
                  this.options[i].children.splice(spliceNum[index] - index,1)
                }
                
                if(this.options[i].children.length == 0){
                  delete this.options[i]
                }
              }
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (
                  this.belongPicList[i].id == this.allowLib[j].split("-")[0]
                ) {
                  flag++;
                  this.belongPicList[i].children.push({
                    id: this.allowLib[j].split("-")[1],
                    name: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.belongPicList[i].children;
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            if (this.belongPicList[i].hasOwnProperty("children")) {
              if (this.belongPicList[i].children.length > 0) {
                let spliceNum = []
                for (
                  let z = 0;
                  z < this.belongPicList[i].children.length;
                  z++
                ) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.belongPicList[i].children[z].id) {
                      // if(data[j].status === 1){
                        this.belongPicList[i].children[z].name = data[j].name
                      // }else{
                      //   spliceNum.push(z)
                      // }
                    }
                  }
                }

                // for (let index = 0; index < spliceNum.length; index++) {
                //   this.belongPicList[i].children.splice(spliceNum[index] - index,1)
                // }
                
                // if(this.belongPicList[i].children.length == 0){
                //   delete this.belongPicList[i]
                // }
              }
            }
          }
        } else {
          this.listMyPowerLibAsync();
          // console.log(this.allowLib);
          // console.log(data);
          // for (let i = 0; i < data.length; i++) {
          //   if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
          //     if (data[i].status === 1) {
          //       this.options.push({
          //         value: data[i].id,
          //         label: data[i].name
          //       });
          //       this.belongPicList.push({
          //         id: data[i].id,
          //         name: data[i].name
          //       });
          //     }

          //   }

          // }
        }
        if (this.options.length > 0) {
          this.atlasForm.libId = this.options[0].value;
        }
      }
      if (data) {
        this.belongPicList = [
          {
            id: 0,
            name: "全部",
          },
        ];
        this.options = [];
        if (localStorage.getItem("createUid") == 60000) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].status === 1) {
              this.options.push({
                value: data[i].id,
                label: data[i].name,
                children: [],
              });
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
                children: [],
              });
            }
          }

          for (let i = 0; i < this.options.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (this.options[i].value == this.allowLib[j].split("-")[0]) {
                  flag++;
                  this.options[i].children.push({
                    value: this.allowLib[j].split("-")[1],
                    label: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.options[i].children;
            }
          }

          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].hasOwnProperty("children")) {
              if (this.options[i].children.length > 0) {
                let spliceNum = []
                for (let z = 0; z < this.options[i].children.length; z++) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.options[i].children[z].value) {
                      if(data[j].status === 1){
                        this.options[i].children[z].label = data[j].name
                      }else{
                        spliceNum.push(z)
                      }
                    }
                  }
                }

                for (let index = 0; index < spliceNum.length; index++) {
                  this.options[i].children.splice(spliceNum[index] - index,1)
                }
                
                if(this.options[i].children.length == 0){
                  delete this.options[i]
                }
              }
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            let flag = 0;
            for (let j = 0; j < this.allowLib.length; j++) {
              if (this.allowLib[j].toString().indexOf("-") !== -1) {
                if (
                  this.belongPicList[i].id == this.allowLib[j].split("-")[0]
                ) {
                  flag++;
                  this.belongPicList[i].children.push({
                    id: this.allowLib[j].split("-")[1],
                    name: "",
                  });
                }
              }
            }
            if (flag == 0) {
              delete this.belongPicList[i].children;
            }
          }

          for (let i = 0; i < this.belongPicList.length; i++) {
            if (this.belongPicList[i].hasOwnProperty("children")) {
              if (this.belongPicList[i].children.length > 0) {
                for (
                  let z = 0;
                  z < this.belongPicList[i].children.length;
                  z++
                ) {
                  for (let j = 0; j < data.length; j++) {
                    if (data[j].id == this.belongPicList[i].children[z].id) {
                      this.belongPicList[i].children[z].name = data[j].name;
                    }
                  }
                }
              }
            }
          }
        } else {
          this.listMyPowerLibAsync();
          // for (let i = 0; i < data.length; i++) {
          //   if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
          //     if (data[i].status === 1) {
          //       this.options.push({
          //         value: data[i].id,
          //         label: data[i].name,
          //       children:[]
          //       });
          //       this.belongPicList.push({
          //         id: data[i].id,
          //         name: data[i].name
          //       });
          //     }

          //   }

          // }
        }
        if (this.options.length > 0) {
          this.atlasForm.libId = this.options[0].value;
        }
      }

      // this.mapDepot = this.belongPicList.unshift()
      // console.log(this.belongPicList, this.mapDepot);
    },

    //判断分辨率
    judgRes() {
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px";
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px";
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px";
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px";
      }
    },

    //判断gril的row值
    checkRow() {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2800) {
        this.row = 9;
        this.widthWithUP = "13%";
        this.faceRow = 7;
        this.widthWithUPFace = "23.5%";
      } else if (this.displayResolution > 2700) {
        this.row = 8;
        this.widthWithUP = "13%";
        this.faceRow = 6;
        this.widthWithUPFace = "23.5%";
      } else if (this.displayResolution > 2500) {
        this.row = 7;
        this.widthWithUP = "13%";
        this.faceRow = 5;
        this.widthWithUPFace = "23.5%";
      } else if (this.displayResolution > 2400) {
        this.row = 6;
        this.widthWithUP = "14%";
        this.faceRow = 4;
        this.widthWithUPFace = "23.5%";
      } else if (this.displayResolution > 2000) {
        this.row = 5;
        this.widthWithUP = "16%";
        this.faceRow = 3;
        this.widthWithUPFace = "23.5%";
      } else if (this.displayResolution > 1900) {
        this.row = 5;
        this.widthWithUP = "18%";
        this.faceRow = 3;
        this.widthWithUPFace = "23.5%";
      } else if (this.displayResolution > 1700) {
        this.row = 4;
        this.widthWithUP = "18%";
        this.faceRow = 3;
        this.widthWithUPFace = "23.5%";
      }
      if (this.displayResolution <= 1700) {
        this.row = 4;
        this.widthWithUP = "21.5%";
        this.faceRow = 2;
        this.widthWithUPFace = "25%";
      }
      if (this.displayResolution <= 1600) {
        this.row = 4;
        this.widthWithUP = "22.5%";
        this.faceRow = 2;
        this.widthWithUPFace = "25%";
      }
      if (this.displayResolution <= 1550) {
        this.row = 4;
        this.widthWithUP = "22.5%";
        this.faceRow = 2;
        this.widthWithUPFace = "25%";
      }
      if (this.displayResolution <= 1400) {
        this.row = 3;
        this.widthWithUP = "25%";
        this.faceRow = 2;
        this.widthWithUPFace = "25%";
      }
    },
  },
  created() {
    // console.log(this.isSimple);

    this.checkStatus();

    // console.log(this.isReLoad)

    this.atlasForm.status = this.visibilityList[1].value;

    this.isRefresh = true
    //获取图集
    this.searchAtlasAsync({ pageSize: this.pageSize, page: this.page, orderByTime: this.orderByTime, createUid: this.createUid })

    //获取图库列表
    this.listLibAsync();

    // this.listMyPowerLibAsync()

    this.displayResolution = document.documentElement.clientWidth;

    this.documentHeight = document.documentElement.clientHeight;

    if (this.documentHeight <= 650) {
      this.minRows = 0;
      this.maxRows = 1;
    } else if (this.documentHeight <= 775) {
      this.minRows = 4;
      this.maxRows = 8;
    } else if (this.documentHeight <= 970) {
      this.minRows = 8;
      this.maxRows = 12;
    }

    setInterval(() => {
      this.judgRes();
      // this.refresh()
    }, 888);
  },
  // activated: function () {
  //   this.refresh()
  // },
  mounted() {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    this.bus.$on("changeIsaside", (message) => {
      this.bus.val = message;
      this.isAside = this.bus.val;
      // this.isChildren = false
    });
  },
  destroyed() {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./personpic.scss";
@import "@/constants/elHeader.scss";
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
/deep/ ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
/deep/ ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}

.el-table /deep/ .el-table__body tr td {
  cursor: pointer;
}
.el-table /deep/ .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table /deep/ .el-table__body .current-row td .cell {
  color: #fff !important;
}

// .el-radio-group /deep/ .is-active .el-radio-button__inner {
//   background: #185ed3;
//   border-color: #185ed3;
// }
.seeInfo {
  background: #f2f2f2 !important;
  border: 1px solid rgba(119, 119, 119, 0.1);
  color: #333333;
  margin-right: 2px;
}
.batchN /deep/ .el-button {
  font-size: 14px;
  margin-left: 20px;
}
/deep/ .el-switch__label.is-active {
  color: #606266;
}
</style>
